import { createSelector } from "reselect"
import { get, isEmpty, chain, sum, size } from "lodash"
import { ASSET_TYPES } from "helpers/assets/constants"

const EMPTY_OBJECT = {}

const getModeledDates = (state) => get(state, "global.data.modeledDates.data.model.availability.dates")
export const getInstrument = (state, props) => get(props, "currentTopic.referenceInstrument", EMPTY_OBJECT)
export const getInstrumentDescriptors = state => get(state, "global.data.smartTradeInstrumentDescriptors.data.model.security.descriptors", EMPTY_OBJECT)
export const getInstrumentPortfolioPositions = state => get(state, "global.data.instrumentPortfolioPositions.data.portfolio.dates.0")
export const getInstrumentLongOrShort = state => get(state, "global.data.instrumentPortfolioModelMeta.data.type")
const getRawInstrumentPortfolio = state => get(state, "global.data.instrumentPortfolio.data.portfolio")
export const getInstrumentPortfolioGMV = createSelector(
  [getInstrumentPortfolioPositions],
  (datePositions) => {
    const { equity, gmv } = datePositions || {}
    return equity || gmv
  },
)

export const getInstrumentPortfolio = createSelector(
  [getRawInstrumentPortfolio, getInstrumentPortfolioPositions],
  (instrumentPortfolio, positions) => !isEmpty(instrumentPortfolio) && ({
    ...instrumentPortfolio,
    ...(get(positions, "equity") && { equity: get(positions, "equity") }),
    ...(get(positions, "indexes") && { indexes: get(positions, "indexes") }),
  }),
)

export const getInstrumentPortfolioLongShortGMVs = createSelector(
  [getInstrumentPortfolioPositions],
  (positions) => chain(positions)
    .pick(ASSET_TYPES)
    .flatMap((pos) => pos)
    .map((pos) => get(pos, "economicExposure"))
    .groupBy((value) => value < 0 ? "short" : "long")
    .mapValues((values) => Math.abs(sum(values)))
    .value(),
)

export const getModelHasDates = createSelector(
  [getModeledDates],
  (modeledDates) => size(modeledDates) > 0,
)
